export default __webpack_public_path__ + "static/media/landing page logo.c0d61048.png";